import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {Button} from '../../../../../../shared/components/button';
import {ProductAcceptorFilterList} from '../../list';
import {ProductsAcceptorFilterViewBaseProps} from '../../../model';

export default ({productAcceptors, onSubmit}: ProductsAcceptorFilterViewBaseProps) => {
  const styles = useStyles(() => ({
    container: {
      paddingBottom: 30,
    },
    filterButtonContainer: {},
    filterButton: {},
  }));
  return (
    <View style={styles.container}>
      <ProductAcceptorFilterList visuallyImpaired productAcceptors={productAcceptors} />
      <View style={[styles.filterButtonContainer]}>
        <Button id='filter-show' text='Показать' type='secondary' style={styles.filterButton} onPress={onSubmit} />
      </View>
    </View>
  );
};
